<template lang="pug">
    .col-md-6.col-sm-6.col-xs-12.box-parent-video
      .box-item-video
        router-link.grade-format(:to="{ path: '/' + url + '/video/' + video.grade_id}" target= '_blank')
          span.grades {{video.grade_name}}
        .overlay
          a(:href="getLinkDetail(video)" v-if="this.$store.getters.isLoggedIn" target= '_blank')     
            span.material-icons play_arrow
          a(:href="getLinkDetail(video)" target= '_blank' v-else)
            span.material-icons play_arrow
        img(:src="video.thumbnail" v-if="video.thumbnail && video.thumbnail !== null && video.thumbnail.length > 0")
        img(src="../../../assets/Obee_Logo_140@2x.png" v-else)
      .item-title
        a(v-if="this.$store.getters.isLoggedIn" :href="getLinkDetail(video)" target= '_blank') {{ video.name }}
        a(:href="getLinkDetail(video)" target= '_blank' v-else) {{ video.name }}
      .item-social
        span
          i.like.fa(@click="likeVideo(video.id)" v-if="!liked || !$store.getters.user")
            img(src="../../../assets/images/home/ic_like_outline.svg")
            | {{ numberWithCommas(video.count_like) }}
          i.like.fa(@click="unLikeVideo(video.id)" :data-id="video.id" v-else)
            img(src="../../../assets/images/home/ic_like.svg")
            | {{ numberWithCommas(video.count_like) }}
        span
          i.fa
            img(src="../../../assets/images/home/ic_comment.svg")
            | {{ numberWithCommas(video.count_comment) }}
        span
          i.fa
            img(src="../../../assets/images/home/ic_share.svg")
            | {{ numberWithCommas(video.count_share) }}
        span 
          i.materials.material-icons visibility
          | {{ numberWithCommas(video.read) }}
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    MdNotification
  },
  props: {
    video: Object,
    obj_id: Number,
    url: String
  },
  data() {
    return {
      object_id: this.obj_id,
      isSucess: false,
      liked: false,
      message: this.$t('home.comming_soon')
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    getLinkDetail(item) {
      var link = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + this.url
      return link + '/video/detail/' + item.id
    },
    likeVideo(id) {
      this.$apollo.mutate({
        mutation: gql(graphql.LIKE_LESSONS_HOME),
        variables: {
          object_id: id,
          user_id: this.$store.getters.user
        },
        update: (store, { data: { insert_likes_lesson } }) => {
          if (insert_likes_lesson.affected_rows) {
            this.liked = true
            this.video.count_like++
          }
          this.isSucess = false
        }
      })
    },
    unLikeVideo(id) {
      this.$apollo.mutate({
        mutation: gql(graphql.UNLIKE_LESSONS_HOME),
        variables: {
          object_id: id,
          user_id: this.$store.getters.user
        },
        update: (store, { data: { delete_likes_lesson } }) => {
          if (delete_likes_lesson.affected_rows) {
            this.liked = false
            if (this.video.count_like > 0) this.video.count_like--
          }
          this.isSucess = false
        }
      })
    },
    getScrollTop(element) {
      if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      return element.scrollTop
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  async mounted () {
    this.liked = false
    const {data} = await this.$apollo.query({
      query: gql(graphql.GET_LESSONS_LIKE_HOME),
      fetchPolicy: 'no-cache',
      variables: {
        object_id: this.object_id,
        user_id: this.$store.getters.user
      }})
    this.liked = data.likes_lesson.length
  },
  apollo: {
  }
}
</script>



// WEBPACK FOOTER //
// item.vue?4d1993f4